
<mat-form-field>
  <mat-select [disabled]="disabled" [formControl]="userCtrl" [placeholder]="placeholder" multiple (closed)="setUsers()">
    <mat-option>
      <ngx-mat-select-search [formControl]="userFilterCtrl"
        placeholderLabel="Find user..."
      noEntriesFoundLabel="no matching user found"></ngx-mat-select-search>
    </mat-option>
    <mat-select-trigger>
      {{userCtrl.value && userCtrl.value.length >= 1 ? userCtrl.value[0].displayName : 'None Selected'}}
      @if (userCtrl.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{userCtrl.value.length - 1}} {{userCtrl.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (user of filteredUsers | async; track user) {
      <mat-option [value]="user">
        {{user.displayName}}
      </mat-option>
    }
  </mat-select>
  @if (loading) {
    <mat-spinner matSuffix diameter=25 strokeWidth=4></mat-spinner>
  }
</mat-form-field>

@if (displayUserList) {
  @if (removableSelectionList) {
    <div class="selected-items">
      <h5>Selected users</h5>
      @if (userCtrl.value?.length) {
        <ul class="list">
          @for (user of userCtrl.value; track user) {
            <li>
              <span>{{user.displayName}}</span>
              <button type="button" class="selection-remove" (click)="removeUser(user)" [attr.aria-label]="'Remove ' + user.displayName">
                <mat-icon>close</mat-icon>
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="selection-empty">No users selected</p>
      }
    </div>
  } @else {
    <div class="row">
      <div class="col-12">
        <h5>Selected Users:</h5>
        <ul class="list">
          @for (user of userCtrl.value; track user) {
            <li>{{user.displayName}}</li>
          }
        </ul>
      </div>
    </div>
  }
}

<!-- <mat-form-field appearance="fill" style="width: 100%">
<mat-label>Users</mat-label>
<mat-select name="users" [formControl]="selectedUsersFC" multiple (closed)="setUsers()">
  <mat-select-trigger>
    {{selectedUsersFC.value && selectedUsersFC.value.length >= 1 ? selectedUsersFC.value[0].displayValue : 'None Selected'}}
    <span *ngIf="selectedUsersFC.value?.length > 1" class="example-additional-selection">
      (+{{selectedUsersFC.value.length - 1}} {{selectedUsersFC.value?.length === 2 ? 'other' : 'others'}})
    </span>
  </mat-select-trigger>
  <mat-option *ngFor="let user of users" [value]="user">{{user.displayValue}}</mat-option>
</mat-select>
</mat-form-field> -->
